<template>
  <div class="grey-battery-widget" :style="[holderStyle, parentStyle]">
    <div class="battery" :class="{mini:mini}" :style="[holderStyle]"> 
      <span ref="bolt_display" class="fa fa-exclamation warning-bolt" style="color: #df0a00" :style="[boltStyle]"></span>
      <div class="level" v-bind:style="battery_meter" ref="battery_level"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "grey-battery",
  props: ["height", "width", "direction", "level", "mini"],
  data: function() {
    return {
      boltDisplay: false,
      // batteryLevel: 0,
      battery_meter: {
        background: "green",
        width: this.level + "%" || "100%",
        height: "100%"
      },
      holderStyle: {
        width: this.width || "100px",
        height: this.height || "30px",
        background: "#eee"
      },
      parentStyle: {
        transform: this.direction == "y" ? "rotate(-90deg)" : ""
      },
      boltStyle: {
        display:'none', 
        transform: this.direction == "y" ? "rotate(90deg)" : ""
      }
    };
  },
  watch: {
    level: function(newVal, old) {
      // console.log(old, newVal);
      this.batteryLevel = newVal;
      this.batUpdate(newVal);
      // this.boltDisplay = 
    }
  },
  components: {},
  methods: {
    batUpdate(charge) {
      this.$refs.battery_level.style.width = charge + "%";
      var bg;
       this.$refs.bolt_display.style.display = 'none';
      if (charge <= 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
         this.$refs.bolt_display.style.display = 'block';
        bg =
          "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg =
          "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg =
          "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      // if(charge <80){
         
      // }
      // console.log(this.$refs.battery_level);
      this.battery_meter.background = bg;
      this.$refs.battery_level.style.background = bg;
    }
  },
  mounted() {
    this.batUpdate(this.level);
  },
  updated() {}
};
</script>

<style lang="scss" scoped>
// @import "../../../sass/_variables.scss";

$batteryWidth: "100%";
$batteryHeight: "100%";
$batteryBorderSize: 0.3px;
$batteryStrokeColor: rgba(0, 0, 0, 0.3);
$batteryBorderRadius: 2px;
$batteryNubSize: calc(0.5 * #{$batteryHeight});
$nubTopMargin: calc(-0.28 * #{$batteryNubSize});

// .grey-battery-widget{
//   position: relative;
// }
.battery {
  position: relative;
  width: $batteryWidth;
  height: $batteryHeight;
  // border: $batteryBorderSize solid $batteryStrokeColor;
  border-radius: $batteryBorderRadius;
  position: relative;
  z-index: 2;
  // padding: $batteryBorderSize;
  background: $batteryStrokeColor;
  // background-image: linear-gradient(to right, transparent 5%, #316d08 5%, #316d08 7%, #60b939 8%, #60b939 10%, #51aa31 11%, #51aa31 60%, #64ce11 61%, #64ce11 63%, #255405 63%, black 68%, black 95%, transparent 95%), linear-gradient(to bottom, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.4) 4%, rgba(255, 255, 255, 0.2) 7%, rgba(255, 255, 255, 0.2) 14%, rgba(255, 255, 255, 0.8) 14%, rgba(255, 255, 255, 0.2) 40%, rgba(255, 255, 255, 0) 41%, rgba(255, 255, 255, 0) 80%, rgba(255, 255, 255, 0.2) 80%, rgba(255, 255, 255, 0.4) 86%, rgba(255, 255, 255, 0.6) 90%, rgba(255, 255, 255, 0.1) 92%, rgba(255, 255, 255, 0.1) 95%, rgba(255, 255, 255, 0.5) 98%);
  // -webkit-transform: scale(0.5);//for retina display
  display: flex;
  // justify-content: center;
  align-items: center;
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: calc(50% - 2px);
    right: -3px;
    z-index: -1;
    margin-top: #{$nubTopMargin};
    width: 4px;
    height: #{$batteryNubSize};
    background: $batteryStrokeColor;
    // border-top-right-radius: 60%;
    // border-bottom-right-radius: 60%;
  }
  &.mini{
    .warning-bolt{
      font-size: 13px;
    }
  }
  // +.mini{
  &.mini:before {
    top: 50%;
    right: -1.5px;
    width: 3px;
  }
  // }
  &.plugged:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    // right: -1 * calc($batteryBorderSize + calc($batteryWidth * 0.5));
    // margin-top: calc(#{$batteryNubSize} / 2) * -1;
    margin-top: (0.5 * #{$batteryNubSize}) * -1;
    width: #{$batteryNubSize};
    height: #{$batteryNubSize};
    background: #f00;
    border-radius: 50%;
  }
  .level {
    width: 20%;
    height: 100%;
    background: $batteryStrokeColor;
    border-radius: $batteryBorderRadius/2;
    align-self: flex-end;
    display: flex;
  }
  .warning-bolt {
    position: absolute;
    // transform: rotate(90deg);
    font-size: 28px; 
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/grey-battery.vue